import * as React from "react";
import { lightTheme } from "@/customTheme";
const SVGComponent = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {props.disabled ? (
      <circle cx={8} cy={8} r={8} fill={'#CBCBCB'} />
    ) : (
      <>
        <circle cx={8} cy={8} r={8} fill="#FCD34D" />
        <circle cx={8} cy={8} r={8} fill="url(#paint0_linear_4847_1521)" />
      </>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.94768 4C9.65069 4 10.0024 3.99992 10.1313 4.22754C10.2601 4.45526 10.0786 4.75681 9.71624 5.35938L9.01506 6.52637C8.8081 6.87056 8.70435 7.04274 8.77776 7.17285C8.85133 7.30293 9.05204 7.30276 9.45354 7.30273H10.433C11.1599 7.3027 11.5237 7.30336 11.601 7.5127C11.6779 7.72192 11.4018 7.95845 10.85 8.43066L6.63616 12.0361C6.00461 12.5766 5.68917 12.8465 5.52581 12.7295C5.36246 12.6122 5.51722 12.2265 5.82756 11.4551L6.56292 9.62695C6.6912 9.30809 6.75535 9.14798 6.67913 9.03516C6.60278 8.9227 6.43066 8.92283 6.08733 8.92285H5.34807C4.88 8.92289 4.6459 8.92251 4.55217 8.76953C4.45864 8.61655 4.56518 8.40817 4.77776 7.99121L6.49163 4.62988C6.64784 4.32348 6.72603 4.1699 6.86467 4.08496C7.00327 4.00019 7.17528 4 7.51897 4H8.94768Z"
      fill="white"
    />
    {!props.disabled && (
      <defs>
        <linearGradient
          id="paint0_linear_4847_1521"
          x1={0}
          y1={8}
          x2={16}
          y2={8}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={lightTheme.colors.superPurple} />
          <stop offset={1} stopColor={lightTheme.colors.superMagenta} />
        </linearGradient>
      </defs>
    )}
  </svg>
);
export default SVGComponent;
